import { useEffect, useRef } from "react";
import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

const BaseCheckbox = styled.input<any>`
  ${({ theme: { space } }) => `
       height: 16px;
       width: 16px;
       margin-right: ${space[1]};
       min-width: 16px;
    `}
`;

const Label = styled.label<{ alignValue?: string; isDisabled?: boolean }>`
  ${space}
  ${({ theme: { colors, fontSizes } }) => `
        font-family: "Inter", sans-serif;
        font-size: ${fontSizes[1]};
        margin-bottom: none;
        display: block;
        color: ${colors.blue[100]};
        display: flex;

    `}
    align-items: ${(props) => (props.alignValue ? "start" : "center")};
  ${(props) =>
    props.isDisabled ? "cursor: not-allowed; opacity: 0.5;" : ""}
`;

interface CheckboxProps extends SpaceProps {
  isChecked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: any;
  name?: string;
  alignValue?: string;
  isDisabled?: boolean;
  /** Renders the "partially selected" dash (e.g. a group with some children checked). */
  isIndeterminate?: boolean;
  title?: string;
}

export const Checkbox = (props: CheckboxProps) => {
  const {
    isChecked,
    onChange,
    label,
    name,
    isDisabled,
    isIndeterminate,
    ...styleProps
  } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);

  // `indeterminate` is a DOM property only — there's no HTML attribute for it.
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(isIndeterminate) && !isChecked;
    }
  }, [isIndeterminate, isChecked]);

  const handleChange = (event: any) => {
    if (isDisabled) return;
    onChange(event);
  };

  return (
    <Label isDisabled={isDisabled} {...styleProps}>
      <BaseCheckbox
        ref={inputRef}
        checked={isChecked}
        onChange={handleChange}
        type="checkbox"
        name={name}
        disabled={isDisabled}
      />
      {label}
    </Label>
  );
};
